import GalleryCarousel from "../../components/GalleryCarousel";

function GalleryPage(){

return(

<div>

<h1 style={{textAlign:"center", marginTop:"120px"}}>
College Gallery
</h1>

<GalleryCarousel/>

</div>

);

}

export default GalleryPage;